export const contactsData = {
    email: 'adityarajinagavle@gmail.com',
    phone: '+917350898228',
    address: 'Kolhapur, Maharashtra, India - 416213 ',

    sheetAPI: 'https://sheetdb.io/api/v1/uon4djj3qh5p8'
}